var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "editor-container" }, [
    _c(
      "div",
      {
        staticClass: "edit-block",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.initialiseEditor.apply(null, arguments)
          },
        },
      },
      [
        _c("font-awesome-icon", {
          attrs: { icon: ["far", "edit"], size: "lg" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.existingContent && _vm.editorPlaceholder
      ? _c("div", { staticClass: "editor-placeholder" }, [
          _vm._v(_vm._s(_vm.editorPlaceholder)),
        ])
      : _vm._e(),
    _vm._v(" "),
    this.editorInfo && this.showEditor
      ? _c("div", { staticClass: "editor-info" }, [
          _vm._v(_vm._s(this.editorInfo)),
        ])
      : _vm._e(),
    _vm._v(" "),
    this.showEditor
      ? _c("div", { staticClass: "editor-main" }, [
          _c("textarea", { attrs: { id: _vm.instanceId } }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessages
      ? _c("div", { staticClass: "editor-errors" }, [
          _vm._v(_vm._s(_vm.errorMessages)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }